import type { ButtonTextVariant } from '@kanda-libs/ks-design-library';
import { Address } from '@kanda-libs/ks-frontend-services';

export const DEFAULT_NEXT_BUTTON_PROPS = {
  id: 'apply-for-finance-next-button',
  label: 'Next',
  className: 'w-full',
  icon: 'arrow-right',
  variant: 'gradient' as ButtonTextVariant,
  submit: true,
};

export const EXAMPLE_ADDRESS: Address = {
  building_number: '17',
  line_1: '17 High Street',
  city: 'Henley-in-Arden',
  county: 'West Midlands',
  country: 'England',
  postcode: 'B95 5AA',
};
